export let JobdetailTypography = {
  width: { md: "50%", xs: "90%" },
  margin: "0px auto",
  color: "black",
  fontSize: { md: "45px", xs: "25px" },
};
export let filterJobContainer = {
  marginTop: "10%",
  textAlign: "center",
  position: "relative",
  alignItems: "center",
  justifyContent: "center",
};
export let howtouseContainer = {
  position: "relative",
  margin: "0px auto",
  marginTop: "4%",
  justifyContent: "space-between",
  width: "90%",
};
export let HowtoUseTypography = {
  margin: "5px 0px",
  fontSize: { md: "45px", xs: "30px" },
  textAlign: { md: "left", xs: "center" },
};
export let ContainerImage = {
  position: "absolute",
  width: "100%",
  height: "200%",
};
export let LookingForJobItems = {
  margin: "20px auto",
  width: { md: "100%", xs: "90%" },
  display: "flex",
  justifyContent: { md: "center", xs: "left" },
  padding: { md: "50px", xs: "30px" },
};
export let LookingForJobItems2 = {
  margin: "20px auto",
  width: { md: "100%", xs: "90%" },
  display: "flex",
  justifyContent: { md: "center", xs: "space-between" },
  alignItems: "center",
  padding: { md: "50px", xs: "0px" },
};
export let flagBox = {
  background: "linear-gradient(180deg, #3975F1 20.72%, #06184B 96.02%);",
  padding: "5px",
};
export let flagBoxGrid = {
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  margin: "20px",
};
export let CardTypographyHeading = {
  fontSize: { md: "20px", xs: "16px" },
  fontWeight: "bolder",
  textAlign: "left",
};
export let CTsubheading = {
  fontSize: { md: "16px", xs: "12px" },
  fontWeight: "bold",
  textAlign: "left",
};
export let CTbody = {
  fontSize: { md: "12px", xs: "9px" },
  fontWeight: "bolder",
  textAlign: "left",
  margin: "0px 5px",
};
export let CTbodyskill = {
  fontSize: { md: "12px", xs: "8px" },
  fontWeight: "bolder",
  textAlign: "center",
  padding: "2px 3px",
  margin: "0px 5px",
  backgroundColor: "wheat",
  borderRadius: "20px",
};
export let skill = {
  fontSize: { md: "16px", xs: "14px" },
  fontWeight: "bolder",
  textAlign: "left",
  margin: "10px 0px",
  color: "#081315",
};
export let CardContainer = {
  width: { lg: "550px", md: "80%", xs: "90%" },
  boxShadow: "0px 0px 3px 3px rgba(250,250,250,0.9)",
  padding: "25px",
  backgroundColor: "white",
  borderRadius: "20px",
  margin: "10px auto",
};
export let NewsLatterContainerBox = {
  background: {
    md: "white",
    xs: "linear-gradient(180deg, #3975F1 20.72%, #06184B 96.02%)",
  },
  display: "flex",
  borderRadius: "60px",
  justifyContent: "center",
  flexWrap: "wrap",
  padding:{md:'0',xs:'25px'},
  alignItems: "center",
};
export let NewsLatterImageContainer = {
  position: "absolute",
  right: "15px",
  top: "-5px",
  display: { md: "block", xs: "none" },
};
export let NewsLatterInnerFlexBox = {
  display: "flex",
  alignItems: "center",
  position: "relative",
  margin: "10%",
};
export let NLInputContainer = {
  backgroundColor: "white",
  borderRadius: "20px",
  padding: "5px",
  zIndex: "10000",
  boxShadow: "0px 0px 1px 1px rgba(210,200,200,0.8)",
};
export let NLbottomBox = {
  height: "150px",
  width: "150px",
  position: "absolute",
  bottom: "-15px",
  left:'-15px',
  background: "linear-gradient(180deg, #3975F1 20.72%, #06184B 96.02%)",
  zIndex: "-1000000",
  borderRadius: "0px 60px",
  display:{md:'block',xs:'none'}
};

export let drawerbutton = {
  display: "flex",
  justifyContent: "space-between",
  margin: "20px auto",
  width: "80%",
  color: "white",
  boxShadow: "0px 0px 2px 2px rgba(200, 200, 200, 0.9)",
  background: "linear-gradient(180deg, #3975F1 20.72%, #06184B 96.02%)",
};